import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import TablePaginationActions from "../../../shared/components/Table/Actions";
import { dateFormat, dayOfWeekNameByDate } from "../../../util/DateUtil";

/** Dias registrados do integral (paginado); usada por Presença e Rotina. */
const IntegralPresencaTable = ({ listaPresenca, setIntegralPresenca, handleChangePage }) => {
  if (listaPresenca.content.length === 0) {
    return (
      <Box
        sx={{
          py: 6,
          textAlign: "center",
          color: "text.secondary",
          border: 1,
          borderStyle: "dashed",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <EventAvailableOutlinedIcon fontSize="large" />
        <Typography variant="body2" mt={1}>
          Nenhum dia registrado.
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
        <Table size="small" aria-label="Dias registrados">
          <TableHead>
            <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
              <TableCell>Data</TableCell>
              <TableCell>Dia da semana</TableCell>
              <TableCell sx={{ width: 48 }} />
            </TableRow>
          </TableHead>
          <TableBody>
            {listaPresenca.content.map((presenca) => (
              <TableRow
                key={presenca.codigo}
                hover
                onClick={() => setIntegralPresenca(presenca)}
                sx={{ cursor: "pointer" }}
              >
                <TableCell>
                  <Typography variant="body2" fontWeight={500}>
                    {dateFormat(presenca.data)}
                  </Typography>
                </TableCell>
                <TableCell sx={{ color: "text.secondary" }}>
                  {presenca.data ? dayOfWeekNameByDate(presenca.data) : "--"}
                </TableCell>
                <TableCell align="right">
                  <ChevronRightIcon fontSize="small" color="action" />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[]}
        rowsPerPage={listaPresenca.size || 0}
        component="div"
        count={listaPresenca.totalElements || 0}
        page={listaPresenca.number || 0}
        onPageChange={handleChangePage}
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? `${count} registros` : `mais de ${to}`}`
        }
        ActionsComponent={TablePaginationActions}
      />
    </>
  );
};

export default IntegralPresencaTable;
